<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">

          <!-- Título da tela -->
          <basic-toolbar :title="'Pesquisar Instituição'"></basic-toolbar>

          <v-card-text>

            <!-- Mensagem informativa -->
            <v-layout row>
              <v-flex xs12>
                <v-alert
                  class="alerta"
                  color="#00796b"
                  type="info"
                  dense
                  outlined
                >
                  Para adicionar uma instituição, realize a pesquisa pelo nome ou sigla da instituição. Caso a instituição desejada não seja encontrada, 
                  clique no botão "CADASTRAR INSTITUIÇÃO".
                </v-alert>
              </v-flex>
            </v-layout>

            <v-form v-model="formularioValido" ref="form">

              <v-container>

                <!-- Filtros para pesquisar instituições -->
                <v-layout row wrap justify-space-between>

                  <v-flex xs6>
                    <v-radio-group v-model="tipoBusca" row>
                      <!-- Filtro por nome -->
                      <v-radio label="Nome" value="nome"></v-radio>
                      <!-- Filtro por sigla -->
                      <v-radio label="Sigla" value="sigla"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs9>
                    <!-- Nome -->
                    <v-text-field
                      v-show="tipoBusca==='nome'"
                      v-model="instituicao.nome"
                      label='Nome'
                      @keyup.enter="pesquisaInstituicoesPorNome()"
                      >
                    </v-text-field>
                    <!-- Sigla -->
                    <v-text-field
                      v-show="tipoBusca!=='nome'"
                      v-model="instituicao.sigla"
                      label='Sigla'
                      @keyup.enter="pesquisaInstituicoesPorSigla()"
                      >
                    </v-text-field>
                  </v-flex>

                  <!-- Botão "Pesquisar" -->
                  <v-flex xs3 style="padding-top:15px">
                    <!-- Pesquisar por nome -->
                    <v-btn v-if="tipoBusca==='nome'" color="primary" style="margin-left: 15px;" @click="pesquisaInstituicoesPorNome()">Pesquisar</v-btn>
                    <!-- Pesquisar por sigla -->
                    <v-btn v-else color="primary" style="margin-left: 15px;" @click="pesquisaInstituicoesPorSigla()">Pesquisar</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>

            </v-form>

            <br><br>

            <v-divider></v-divider>

            <!-- Tabela com as instituições -->
            <v-data-table
            :headers="headers"
            :items="listaInstituicoes"
            :search="search"
            :no-data-text="'Nenhuma instituição encontrada'"
            must-sort
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items-per-page="itemsPerPage"
            :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
            >

              <!-- Formata a sigla -->
              <template v-slot:item.sigla="props">{{ props.item.sigla === null || props.item.sigla === '' ? '-' : props.item.sigla }}</template>

              <!-- Adicionar instituição -->
              <template v-slot:item.opcoes="props">
                
                <c-tooltip-btn
                  icon="add_box"
                  color="primary"
                  tooltip="Adicionar instituição"
                  @click="toAdicionarInstituicaoProjetoPesquisa(props.item.id)"
                ></c-tooltip-btn>

              </template>

              <!-- Número total de instituições -->
              <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
                Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaInstituicoes.length }} {{ listaInstituicoes.length > 1 ? 'instituições' : 'instituição' }}
              </template>

            </v-data-table>

            <br>

            <v-divider></v-divider>

            <v-card-actions>

              <!-- Botão "Cancelar" -->
              <v-btn color="primary" @click="cancelar()">Cancelar</v-btn>

              <v-spacer></v-spacer>

              <!-- Botão "Cadastrar Órgão" -->
              <v-btn color="primary" @click="cadastrarInstituicao()">Cadastrar Instituição</v-btn>

            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import TootipButton from '@/components/c-tooltip-btn'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjetoPesquisa', 'projetoPesquisa'],
    data: () => ({
      tipoBusca: 'nome',
      instituicao: {
        nome: '',
        sigla: ''
      },
      projetoPesquisa: {},
      listaInstituicoes: [],
      search: null,
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
      headers: [
        { text: 'Nome', align: 'left', value: 'nome' },
        { text: 'Sigla', align: 'left', value: 'sigla' },
        { text: 'Opções', align: 'left', value: 'opcoes' }
      ]
    }),
    computed: {
      ...mapGetters('auth', ['administrador'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

      // Pesquisa instituições por nome.
      pesquisaInstituicoesPorNome () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando instituições...' })
        projetos.getPesquisaInstituicoesPorNome(this.instituicao.nome)
        .then(response => {
          this.listaInstituicoes = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
          this.listaInstituicoes = []
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando instituições...' })
        })
      },

      // Pesquisa instituições por sigla.
      pesquisaInstituicoesPorSigla () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando instituições...' })
        projetos.getPesquisaInstituicoesPorSigla(this.instituicao.sigla)
        .then(response => {
          this.listaInstituicoes = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
          this.listaInstituicoes = []
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando instituições...' })
        })
      },

      // Cadastra uma instituição.
      cadastrarInstituicao () {
        this.$router.push({ name: 'ProjetoPesquisaCadastrarInstituicao', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
      },

      // Adiciona uma instituição ao projeto de pesquisa.
      toAdicionarInstituicaoProjetoPesquisa: function (idInstituicao) {
        this.$router.push({ name: 'ProjetoPesquisaAdicionarInstituicao', params: {idProjetoPesquisa: this.idProjetoPesquisa, idInstituicao: idInstituicao} })
      },

      // Redireciona para a página anterior.
      cancelar: function () {
        this.$router.go(-1)
      }
    },
    mounted () {
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'c-tooltip-btn': TootipButton
    }
  }
</script>

<style scoped>

  .alerta {
    margin-top: 1.5em;
    margin-bottom: 2.0em;
  }

</style>

<style lang="css">
  .menu {
    display: block !important;
  }

  .center {
    text-align: center;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// pesquisar-instituicao.vue?7ed8fd86